export default "__VITE_ASSET__CV2HSskO__"